import ILocationViewModel from './ILocationViewModel';

// Movit view models
export default interface IAddressViewModel {
    address: string;
    city: string;
    postalcode: string;
    location: ILocationViewModel;
    type: number;
    category: string; 
}

export enum AddressTypeEnum {
    Origin = 1,
    Destination = 2
}
